import { CSSProperties, ReactNode } from 'react'
import './DetailRow.css'

const DetailRow = ({ children, style }: { children: ReactNode, style?: CSSProperties }) => {
    return (
        <div className='drawer-detail-row' style={style}>{children}</div>
    )
}

export default DetailRow
